export class OutOptions {
  contactWithAdditionalServices: boolean;
  contactWithMarketingMaterials: boolean;
}
